import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { differenceInCalendarDays, addDays } from 'date-fns';

function DateGapCount() {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [includeEndDate, setIncludeEndDate] = useState(false);
  const [duration, setDuration] = useState<string | null>(null);

  const handleCalculate = () => {
    if (startDate && endDate) {
      let days = differenceInCalendarDays(endDate, startDate);
      if (includeEndDate) {
        days += 1;
      }
      setDuration(`The duration is ${days} days.`);
    }
  };

  return (
    <Grid container spacing={2} justifyContent='center'>
      <Grid item xs={12}>
        <TextField
          label='Start Date'
          type='date'
          value={startDate ? startDate.toISOString().slice(0, 10) : ''}
          onChange={(e) =>
            setStartDate(e.target.value ? new Date(e.target.value) : null)
          }
          sx={{ width: 220 }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='End Date'
          type='date'
          value={endDate ? endDate.toISOString().slice(0, 10) : ''}
          onChange={(e) =>
            setEndDate(e.target.value ? new Date(e.target.value) : null)
          }
          sx={{ width: 220 }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={includeEndDate}
              onChange={(e) => setIncludeEndDate(e.target.checked)}
            />
          }
          label='Include end date in calculation (1 day is added)'
        />
        <Button variant='contained' onClick={handleCalculate} sx={{ ml: 2 }}>
          Calculate Duration
        </Button>
        {duration && <Typography sx={{ mt: 2 }}>{duration}</Typography>}
      </Grid>
    </Grid>
  );
}

export default DateGapCount;
